import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { decodeJWT } from '../utils'

const useAuth = () => {
  const [user, setUser] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      try {
        const decoded = decodeJWT(token)
        setUser(decoded)
        setIsAdmin(decoded?.role === 'Admin' || decoded?.role === 'Global Admin')
      } catch (error) {
        console.error('Invalid token:', error)
        setUser(null)
        setIsAdmin(false)
      }
    }
  }, [])

  return { user, isAdmin }
}

export default useAuth
